export default __webpack_public_path__ + "d4777d0044d81248658ecc96e6c027d3.png";